import { motion } from "framer-motion";
import { WhatsAppIcon } from "./WhatsAppIcon";
import { whatsappUrl } from "@/lib/contact";

export default function WhatsAppFloat() {
  return (
    <motion.a
      href={whatsappUrl()}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Scrivici su WhatsApp"
      initial={{ opacity: 0, scale: 0.6 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.5, delay: 1.4, ease: [0.16, 1, 0.3, 1] }}
      whileHover={{ scale: 1.08 }}
      whileTap={{ scale: 0.94 }}
      className="group fixed bottom-24 right-4 z-50 flex items-center gap-3 md:bottom-6 md:right-6"
      data-testid="whatsapp-float-button"
    >
      <span className="pointer-events-none hidden translate-x-2 border border-line bg-white px-4 py-2 text-sm font-semibold text-navy opacity-0 shadow-lg transition-all duration-300 group-hover:translate-x-0 group-hover:opacity-100 md:block">
        Scrivici su WhatsApp
      </span>
      <span className="relative flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-xl">
        <span className="absolute inset-0 animate-ping rounded-full bg-[#25D366] opacity-25" />
        <WhatsAppIcon className="relative h-7 w-7" />
      </span>
    </motion.a>
  );
}
